module.exports = __webpack_public_path__ + "img/scd.6c83201b.jpg";